import { AppSettings } from "../managers/AppSettings";
import { ButtonBase } from "../../ui/ButtonBase";
import { PopupWindow } from "./PopupWindow";
import { IInteractive } from "../../interfaces/IInteractive";
import { IShowable } from "../../interfaces/IShowable";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppTimings } from "../data/AppConstants";


export class TablePopupWindow extends PopupWindow implements IInteractive, IShowable {
    protected inputData: any;

    public override Show(animated: boolean = true): void {
        // console.log("TablePopupWindow::Show; animated=", animated);

        // kill tweens
        // this.scene.tweens.killTweensOf(..);

        // reset
        this.alpha = 0;
        // this.scale = 0;

        // if animate
        const genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                // scale: 1,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            //
            // this.scale = 1;
            this.alpha = 1;
        }
        this.isShowing = true;
    }

    public override Hide(animated: boolean = true, onComplete?: Function): void {
        // console.log("PopupBase::Hide; animated=", animated);

        // kill tweens
        // this.scene.tweens.killTweensOf();

        // ref

        // if animate
        let genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
        // genericHideDuration = 5000;
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                // scale: 0,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
                onComplete: () => onComplete?.(),
            })
        }
        else {
            this.alpha = 0;
            // this.scale = 0;
            onComplete?.();
        }
        this.isShowing = false;
    }

    public SetData(inputData: any): void {
        this.inputData = inputData;
    }
}